import flutterIcon from '../assets/mobile-skill/flutter.png'
import dartIcon from '../assets/mobile-skill/dart.png'

export const MobileSkillList = [
    { icon: dartIcon, title: "Dart" },
    { icon: flutterIcon, title: "Flutter" }
];